import { get_token} from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import { view_profile as view_profile_helper } from "@/views/home/home_helper.js";
export default {
    components: {
    HomeNavBar,
    MenuSideBar,
    StickyNav,
    InactivityModal,
  },

    data() {
        return ({
            loading: true,
            upcoming_birthdays: [],
            birthdaySearch: '',
        });
    },
    mounted() {
        this.token_exists = get_token();
        this.get_upcoming_birthdays();
    },

    computed: {
        filteredBirthdays() {
            const query = this.birthdaySearch.trim().toLowerCase();

            return this.upcoming_birthdays.filter((profile) =>
                this.get_profile_name(profile).toLowerCase().includes(query)
            );
        },
        todayBirthdays() {
    return this.filteredBirthdays.filter(p => this.daysUntilBirthday(p.date_of_birth) === 0);
  },
  upcomingBirthdays() {
    return this.filteredBirthdays
      .filter(p => this.daysUntilBirthday(p.date_of_birth) > 0)
      .sort((a, b) => this.daysUntilBirthday(a.date_of_birth) - this.daysUntilBirthday(b.date_of_birth));
  },
  nextBirthday() {
    return this.todayBirthdays[0] || this.upcomingBirthdays[0] || null;
  }
    },

    methods: {
        getToken() {
            return get_token();
        },
        get_profile_name(profile) {
            const first_name = profile?.base_profile?.creater?.first_name || '';
            const last_name = profile?.base_profile?.creater?.last_name || '';
            return `${first_name} ${last_name}`.trim() || 'Member';
        },
        get_profile_avatar(profile) {
            return profile?.base_profile?.creater?.profile_picture || require('@/assets/images/user.png');
        },
        formatDate(dateStr) {
            if (!dateStr) return 'Date not set';
            const options = { month: 'long', day: 'numeric' };
            return new Date(dateStr).toLocaleDateString(undefined, options);
        },
        daysUntilBirthday(dateStr) {
  if (!dateStr) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0); // reset time
  const dob = new Date(dateStr);
  dob.setHours(0, 0, 0, 0);

  // Set DOB to current year
  dob.setFullYear(today.getFullYear());

  let diff = Math.ceil((dob - today) / (1000 * 60 * 60 * 24));

  // If birthday is today
  if (diff === 0) return 0;

  // If birthday already passed this year
  if (diff < 0) {
    dob.setFullYear(today.getFullYear() + 1);
    diff = Math.ceil((dob - today) / (1000 * 60 * 60 * 24));
  }

  return diff;
},
        get_upcoming_birthdays() {
            // AJAX to your backend API
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_upcoming_birthdays/`,
                method: 'GET',
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                    this.upcoming_birthdays = response.data;
                    this.loading = false;
                },
            });
        },
        view_profile(profile) {
            view_profile_helper(this.$router, profile?.base_profile?.creater || profile);
        }
    }
}
